"use client";

import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SupplierPortalOverview() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="supplier-portal-overview" className="bg-background py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {}
          <div ref={textRef} className={`space-y-6 transition-all duration-300 ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-primary leading-tight">
              Supplier Portal Overview
            </h2>
            
            <p className="font-sans text-lg md:text-xl text-foreground/80 leading-relaxed">
              Connect seamlessly with our advanced supplier platform designed to streamline logistics operations. Access real-time inventory tracking, order management, and comprehensive reporting tools in one centralized hub.
            </p>

            <div className="pt-4">
              <Button className="btn-primary">
                Explore Portal Features
              </Button>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`relative transition-all duration-500 ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="relative overflow-hidden rounded-sm shadow-soft hover:shadow-medium transition-all duration-300" style={{
            transform: imageVisible ? `translateY(${Math.min(window.scrollY * 0.05, 20)}px)` : 'translateY(0)'
          }}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542426/img/modern_logistics_hub_operations.png" alt="Modern logistics hub with advanced supplier portal interface" className="w-full h-auto object-cover" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}